<template>
  <div>
    <!-- Long -->
    <div v-if="displayType === 'long'">
      <p>
        Geographic categories are based on a company's country of domicile.
        Companies classified as "United States" are domiciled in the United States.
        Companies classified as "Developed" are domiciled in Canada, Austria, Italy, Australia, Belgium, Netherlands, Hong Kong, Denmark, Norway, Japan, Finland, Portugal, New Zealand, France, Spain, Singapore, Germany, Sweden, Ireland, Switzerland, Israel, or The United Kingdom.
        Companies domiciled in any other country are classified as "Emerging".
      </p>
      <p>
        This Geographic Breakdown chart applies to directly held securities as well as equities held through funds.
        <template v-if="portfolio && benchmark">
          This breakdown applies to {{ percentCoverage.portfolio }} of {{ portfolio.name }} and {{ percentCoverage.benchmark }} of {{ benchmarkName }}.
        </template>
        <template v-else-if="portfolio">
          This breakdown applies to {{ percentCoverage.portfolio }} of {{ portfolio.name }}.
        </template>
        <template v-else-if="benchmark">
          This breakdown applies to {{ percentCoverage.benchmark }} of {{ benchmarkName }}.
        </template>
      </p>
      <p>Geographic Breakdown data from funds uses holdings as of data of most recent NPORT SEC filing.</p>
    </div>

    <!-- Short -->
    <div v-else>
      <p>Geographic categories are based on a company's country of domicile.</p>
      <p>
        This Geographic Breakdown chart applies to directly held securities as well as equities held through funds.
        <template v-if="portfolio && benchmark">
          This breakdown applies to {{ percentCoverage.portfolio }} of {{ portfolio.name }} and {{ percentCoverage.benchmark }} of {{ benchmarkName }}.
        </template>
        <template v-else-if="portfolio">
          This breakdown applies to {{ percentCoverage.portfolio }} of {{ portfolio.name }}.
        </template>
        <template v-else-if="benchmark">
          This breakdown applies to {{ percentCoverage.benchmark }} of {{ benchmarkName }}.
        </template>
      </p>
    </div>
  </div>
</template>


<script>
export default {
  name: 'GeographyMethodology',
  props: ['displayType', 'portfolio', 'benchmark'],
  computed: {
    benchmarkName() {
      return this.benchmark?.name || 'Benchmark';
    },
    breakdown() {
      return {
        portfolio: this.portfolio?.sector_market_cap_asset_class_breakdown,
        benchmark: this.benchmark?.sector_market_cap_asset_class_breakdown,
      };
    },
    coverage() {
      return {
        portfolio: this.breakdown.portfolio?.geography_breakdown_coverage || 0,
        benchmark: this.breakdown.benchmark?.geography_breakdown_coverage || 0,
      };
    },
    percentCoverage() {
      return {
        portfolio: this.formatNumber(this.coverage.portfolio),
        benchmark: this.formatNumber(this.coverage.benchmark),
      };
    },
  },
  methods: {
    formatNumber(number) {
      return number.toLocaleString('en-US', { style: 'percent' });
    },
  },
};
</script>
